import { Image } from '../common/Image';
import { Link } from '../common/Link';

export type SearchResultsBanner = {
  image: Image;
  mobileImage?: Image;
  link: Link;
  displayType: SearchResultsBannerDisplayType;
};

export enum SearchResultsBannerDisplayType {
  DEFAULT = 'Default',
  NEW_RELEASE = 'New Release Discount',
  ON_SALE = 'Sale',
  FLASH_DEAL = 'Flash Deal',
}

export const SearchResultsBannerDisplayTypePriority = {
  [SearchResultsBannerDisplayType.FLASH_DEAL]: 1,
  [SearchResultsBannerDisplayType.NEW_RELEASE]: 2,
  [SearchResultsBannerDisplayType.ON_SALE]: 3,
  [SearchResultsBannerDisplayType.DEFAULT]: 4,
};
